<div id="pending-users-approve-modal"
     class="fixed flex top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full backdrop-blur-xl justify-center items-center">
  <div id="pending-users-approve-modal-dialog" tabindex="-1" aria-hidden="true" class="w-[700px]">
    <div class="relative p-4 w-full max-w-md max-h-full">
      <!-- Modal content -->
      <div id="pending-users-approve-modal-content" class="relative bg-white rounded-lg shadow dark:bg-gray-700">
        <!-- Modal header -->
        <div id="pending-users-approve-modal-header"
             class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
          <h3 id="pending-users-approve-modal-title" class="text-lg font-semibold text-gray-900 dark:text-white">
            Approve Pending User
          </h3>
          <button id="pending-users-approve-modal-close-btn" type="button" (click)="closeModal()"
                  class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                  data-modal-toggle="crud-modal">
            <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                 viewBox="0 0 14 14">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
            </svg>
            <span class="sr-only">Close modal</span>
          </button>
        </div>
        <!-- Modal body -->
        <form id="pending-users-approve-modal-form" [formGroup]="userForm" class="p-4 md:p-5">
          <div class="grid gap-4 mb-4 grid-cols-1 w-full">
            <div class="col-span-2 pb-2">
              <label for="pending-users-approve-role-select"
                     class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Role</label>
              <div class="input-value-custom">
                <ng-select id="pending-users-approve-role-select"
                           formControlName="roleId"
                           [items]="roles"
                           bindValue="cp_role_id"
                           bindLabel="display_name"
                           notFoundText="No roles found"
                           class="select-custom"
                           placeholder="Select role"
                           (clear)="clearRole()">
                  <ng-template ng-label-tmp let-item="item">
                    {{ item.display_name }}
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    <b>{{ item.display_name }}</b>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="flex mt-2">
              <label for="pending-users-approve-select-all-locations"
                     class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Select All
                Locations</label>
              <input id="pending-users-approve-select-all-locations"
                     formControlName="selectAllLocations"
                     type="checkbox" class="ml-2 border-gray-300 rounded"/>
            </div>
            <div class="col-span-2">
              <label for="pending-users-approve-locations-select"
                     class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Location(s)</label>
              <ng-select id="pending-users-approve-locations-select"
                         formControlName="locationIds"
                         [items]="locations"
                         bindValue="location_id"
                         bindLabel="location_name"
                         placeholder="Select location(s)"
                         required class="select-custom"
                         [multiple]="true"/>
            </div>
          </div>
          <div class="flex justify-end">
            <button id="pending-users-approve-modal-submit-btn" (click)="approveUser()" type="submit"
                    class="text-white inline-flex items-center bg-[#057a55] hover:bg-[#057a60] focus:ring-4 focus:outline-none focus:ring-[#057a55] font-medium rounded-lg text-sm px-5 py-2.5 text-center">
              Approve
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
